// extracted by mini-css-extract-plugin
export default {"title":"Title_title__IlEm8","regtangle":"Title_regtangle__uQyZz","small":"Title_small__0mThK","text":"Title_text__jbAm1"};